<template>
  <HeadlessListbox
    v-slot="{ open }"
    :multiple="props.filter.slug !== 'brands' ? true : false"
    :modelValue="props.filter.slug !== 'brands' ? selectedFilters : selectedBrand?.attributes?.slug || null"
    @update:modelValue="(value: string[] | string) => updateFilters(value)"
  >
    <div class="max-w[220px] relative w-full">
      <HeadlessListboxButton
        class="duration-220 group-disabled:disabled relative flex w-full items-center justify-between whitespace-nowrap rounded-full border border-ng70 py-2 px-5 text-left text-ng400 transition ease-out hover:border-ng50 hover:text-ng600 focus:outline-none focus-visible:ring focus-visible:ring-ng70 focus-visible:ring-opacity-75"
        :class="{
          '!border-ng800 !text-ng800 shadow-md': open || selectedFilters.length,
          'disabled pointer-events-none opacity-70 ': props.filter.filters.length === 0,
          'hover:shadow-md': props.filter.filters.length !== 0,
        }"
      >
        <div class="flex items-center">
          <span class="uppercase">{{ props.filter.name }}</span>
          <Transition name="fade-slide-up" mode="out-in">
            <span
              class="ml-1 inline-flex font-semibold opacity-0 transition duration-200 ease-out"
              :key="JSON.stringify(selectedFilters)"
              :class="{
                'opacity-100': selectedFilters.length,
              }"
              v-if="props.filter.slug !== 'brands'"
              >(<span>{{ selectedFilters.length }}</span
              >)</span
            >
            <span
              class="ml-1 inline-flex text-sm font-semibold"
              v-else-if="props.filter.slug === 'brands' && selectedBrand"
            >
              (<span>{{ selectedBrand?.attributes?.name }}</span
              >)
            </span>
          </Transition>
        </div>
        <DownArrow :rotate="open" icon="ep:arrow-down" size="20" />
      </HeadlessListboxButton>
      <DropdownTransition>
        <HeadlessListboxOptions
          class="absolute z-10 mt-2 w-full overflow-auto rounded-[13px] border border-ng70 bg-white py-2 px-2.5 pb-2.5 uppercase text-ng400"
        >
          <div
            class="flex items-center justify-between border-b border-b-ng70 pb-2"
            v-if="props.filter.slug !== 'brands'"
          >
            <div class="text-xs desktop:text-sm">
              {{ selectedFilters.length }} {{ $t("selected", selectedFilters.length) }}
            </div>
            <button
              class="flex items-center border border-ng70 px-1.5 py-1 uppercase text-ng400 outline-none"
              @click="selectedFilters.length ? clearAllCategoryFilters() : selectAllFilters()"
            >
              <div class="flex items-center justify-center">
                <template v-if="selectedFilters.length === 0">
                  <Icon name="bi:check" size="14" />
                </template>
                <template v-else>
                  <Icon name="bi:x" size="14" />
                </template>
              </div>
              <span class="ml-1.5 text-xs desktop:text-sm">
                {{ $t("all-clear", selectedFilters.length) }}
              </span>
            </button>
          </div>
          <div class="max-h-[276px] overflow-y-auto pt-2" data-lenis-prevent>
            <HeadlessListboxOption
              v-slot="{ active, selected }"
              v-for="filter in props.filter.filters"
              :key="filter.slug"
              :value="filter.slug"
              class="group"
            >
              <button
                class="duration-220 flex w-full items-center rounded-sm px-2 py-2 text-left uppercase text-ng400 transition ease-out hover:bg-ng100 focus:outline-none focus-visible:ring focus-visible:ring-ng70 focus-visible:ring-opacity-75 group-last:rounded-b-[3px]"
                :class="{
                  'bg-ng20': active,
                  'bg-ng40 text-ng800': selected,
                }"
              >
                <!--                <img
                  v-if="filter?.icon?.url"
                  :src="filter.icon.url"
                  draggable="false"
                  class="mr-4 h-5 w-5"
                  :alt="filter.icon.alternativeText || ''"
                  width="18"
                  height="20"
                />-->
                {{ filter.name }}
              </button>
            </HeadlessListboxOption>
          </div>
        </HeadlessListboxOptions>
      </DropdownTransition>
    </div>
  </HeadlessListbox>
</template>
<script setup lang="ts">
import { useFilters } from "~~/stores/filters";
import { SelectedBrandKey } from "~/symbols/symbols";
import { ProductFragment } from "#gql";

const props = defineProps<{
  filter: FilterCategory;
  filteredProducts: ProductFragment[];
}>();
const filterStore = useFilters();

const { t: $t } = useI18n();

const selectedBrand = inject(SelectedBrandKey);

const selectedFilters = computed(() => {
  return filterStore.activeFilters.find((filter) => filter.id === props.filter.id)?.filters || [];
});

function selectAllFilters() {
  if (props.filter?.filters && props.filter.filters.length === 0) return;
  filterStore.addAllFilters(props.filter.id, props.filter.slug, props.filter.filters as Filter[]);
}

function clearAllCategoryFilters() {
  filterStore.clearAllCategoryFilters(props.filter.id);
}
const router = useRouter();

function updateFilters(filters: string[] | string) {
  if (props.filter.slug === "brands" && typeof filters === "string") {
    router.push({ query: { brand: filters } });
  }
  if (Array.isArray(filters)) {
    filterStore.updateFilters({
      id: props.filter.id,
      slug: props.filter.slug,
      name: props.filter.name,
      filters,
    });
  }
}
</script>
<style lang="scss" scoped></style>
